import * as React from "react";
import { useState } from "react";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import usePluginEntities from "hooks/usePluginEntities";
import { eventDefinitionTypeTitle } from "components/event-definitions/pluginTitles";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const EventDefinitionTypeFilter = ({
  attribute,
  allActiveFilters,
  filter,
  filterValueRenderer,
  onSubmit
}) => {
  const [filterQuery, setFilterQuery] = useState(DEFAULT_SEARCH_PARAMS);
  const eventDefinitionTypes = usePluginEntities("eventDefinitionTypes");
  const suggestions = eventDefinitionTypes.filter((edt) => edt.useCondition()).map((edt) => ({ id: edt.type, value: eventDefinitionTypeTitle(edt) })).filter((suggestion) => suggestion.value.toLowerCase().includes(filterQuery.query.toLowerCase())).sort((a, b) => a.value.localeCompare(b.value));
  return /* @__PURE__ */ React.createElement(
    SuggestionsList,
    {
      allActiveFilters,
      attribute,
      multiSelect: !filter,
      filterValueRenderer,
      onSubmit,
      suggestions,
      isLoading: false,
      total: suggestions.length,
      page: 1,
      pageSize: suggestions.length,
      setSearchParams: setFilterQuery
    }
  );
};
export default EventDefinitionTypeFilter;
